module.exports = __webpack_public_path__ + "img/icon_subtitles.93671855.svg";